import { render, staticRenderFns } from "./Manage-AML-Proposal.vue?vue&type=template&id=1eab3ec0"
import script from "./Manage-AML-Proposal.vue?vue&type=script&lang=js"
export * from "./Manage-AML-Proposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports